import type { State } from 'types/redux'
/**
 * Gets the upload state from the Redux state.
 * @param state - The Redux state
 * @returns The upload state object
 */
export const getUpload = (state: State): State['upload'] => state.upload
